export class CustomFieldValue {
  visualElement!: string;
  type!: string;
  value: any;
}
